import { cx } from "@/utils";
import {
  DropdownMenuCheckboxItem,
  DropdownMenuCheckboxItemProps,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

/**
 * DropdownCheckboxItem
 * Container for the DropdownItems
 */

const DropdownCheckboxItem: React.FunctionComponent<
  DropdownMenuCheckboxItemProps
> = ({ className, children, ...props }) => {
  return (
    <DropdownMenuCheckboxItem
      className={cx(styles.base, styles.item, className)}
      {...props}
    >
      {children}
    </DropdownMenuCheckboxItem>
  );
};

export default DropdownCheckboxItem;
